import { entryPointConfig } from './entry-point-config';
import { type Config } from './types';

export function initEntryPointConfig(overrides: Partial<Config>): Config {
	Object.assign(entryPointConfig, overrides);
	return entryPointConfig;
}
